import React from "react";
import BlogPagesTitleBox from "../components/cols/BlogPagesTitleBox";
import NewsLetter from "../components/cols/NewsLetter";
import Body from "../components/Wrapper/Body";
import classes from "../Styles/Blog.module.css";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { blogs } from "../Data/blogs";
import PagesTitleCol from "../components/cols/PagesTitleCol";

const SITE_URL = "https://sprinterwave.com";
const PAGE_URL = `${SITE_URL}/blog`;
const DEFAULT_OG_IMAGE = `${SITE_URL}/images/og/blog-cover.jpg`;

const toAbsoluteUrl = (path) => {
  if (!path) return DEFAULT_OG_IMAGE;
  return path.startsWith("http") ? path : `${SITE_URL}${path}`;
};

function Blog() {
  let suggestedData

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });

  const pageTitle = "Sprinterwave Blog — Bills, Payments & Logistics Tips";
  const pageDescription =
    "Discover insightful articles on financial management, bill tracking, event logistics, and more. Expert tips and guidance to streamline your financial journey and get the most out of the Sprinterwave app.";

  // Structured data: Blog + list of posts, so search engines can pick up
  // rich results for the listing page itself.
  const blogSchema = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: "Sprinterwave Blog",
    url: PAGE_URL,
    description: pageDescription,
    publisher: {
      "@type": "Organization",
      name: "Sprinterwave",
      logo: {
        "@type": "ImageObject",
        url: `${SITE_URL}/images/logo.png`,
      },
    },
    blogPost: blogs.map((cur) => ({
      "@type": "BlogPosting",
      headline: cur.title,
      image: toAbsoluteUrl(cur.image),
      datePublished: cur.date,
      url: `${SITE_URL}/article?page=${cur.page}`,
    })),
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: SITE_URL,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Blog",
        item: PAGE_URL,
      },
    ],
  };

  return (
    <Body>
      <Helmet htmlAttributes={{ lang: "en" }}>
        <meta charSet="utf-8" />

        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="robots" content="index, follow" />
        <meta
          name="keywords"
          content="Transaction processing, Bill payment, Ticket booking, Logistics solutions, Financial management, Mobile payments, Event tickets, Transport services, Mobile app, Payment app, Bill management, Logistics app, Financial transactions, Ticket reservations, Digital payments, Mobile commerce, Convenience app, Utility payments, Event planning"
        />

        <link rel="canonical" href={PAGE_URL} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Sprinterwave" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={PAGE_URL} />
        <meta
          property="og:image"
          content={toAbsoluteUrl(blogs?.[0]?.image)}
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta
          name="twitter:image"
          content={toAbsoluteUrl(blogs?.[0]?.image)}
        />

        <script type="application/ld+json">
          {JSON.stringify(blogSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>


        <PagesTitleCol
              description="Insights on Bills, Payments & Logistics"
              title="Blog"
              bg_imageName="blog"
            />

      <div className={classes.page}>
        <main className={classes.main}>
          <article>
            <h1 className={classes.pageHeading}>
              Insights on Bills, Payments &amp; Logistics
            </h1>
            <p className={classes.pageSubtitle}>
              Practical guides and updates to help you manage your money,
              your bills, and your everyday errands — all in one place.
            </p>

            {blogs.length > 0 ? (
              <div className={classes.post_wrapper}>
                {blogs.map((cur) => (
                  <Link
                    key={cur.page}
                    to={"/article?page=" + cur.page}
                    className={classes.post_link}
                    aria-label={`Read: ${cur.title}`}
                  >
                    <div className={classes.post_list}>
                      <div className={classes.imageFrame}>
                        <img
                          src={cur.image}
                          alt={cur.title}
                          loading="lazy"
                          decoding="async"
                          width={600}
                          height={400}
                        />
                      </div>
                      <div className={classes.cardBody}>
                        <p className={classes.date}>
                          <time>{cur.date}</time>
                        </p>
                        <p className={classes.description}>{cur.title}</p>
                        <span className={classes.readMore}>
                          Read article →
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <p className={classes.emptyState}>
                New articles are on the way — check back soon.
              </p>
            )}
          </article>

          {/* <aside>
            <h1>Recent Posts</h1>

            <div className={classes.suggested_wrapper}>
              {suggestedData.map((cur) => {
                return (
                  <div className={classes.suggested_container}>
                    <img src={cur.image} alt="" />
                    <div>
                      <p className={classes.description_2}>{cur.description}</p>
                      <p className={classes.date}>{cur.date}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className={classes.subscribe}>
              <h3>Subscribe To Newsletter</h3>
              <p>
                Subscribe to our newsletter for exclusive updates, financial
                tips, app feature highlights, and special offers.
              </p>

              <a href="#subscribe_div">
                <button>Subscribe</button>
              </a>
            </div>
          </aside> */}
        </main>

        <div id="subscribe_div">{/* <NewsLetter /> */}</div>
      </div>
    </Body>
  );
}

export default Blog;